var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorderArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#444444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.646 10.1459C12.6925 10.0994 12.7476 10.0624 12.8084 10.0372C12.8691 10.012 12.9343 9.99902 13 9.99902C13.0658 9.99902 13.1309 10.012 13.1917 10.0372C13.2524 10.0624 13.3076 10.0994 13.354 10.1459L19.354 16.1459C19.4479 16.2398 19.5007 16.3671 19.5007 16.4999C19.5007 16.6327 19.4479 16.76 19.354 16.8539C19.2601 16.9478 19.1328 17.0005 19 17.0005C18.8672 17.0005 18.7399 16.9478 18.646 16.8539L13 11.2069L7.35402 16.8539C7.26013 16.9478 7.1328 17.0005 7.00002 17.0005C6.86725 17.0005 6.73991 16.9478 6.64602 16.8539C6.55213 16.76 6.49939 16.6327 6.49939 16.4999C6.49939 16.3671 6.55213 16.2398 6.64602 16.1459L12.646 10.1459Z",
    fill: "#444444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderArrow);
export default __webpack_public_path__ + "static/media/border-arrow.40952a62a6cc75b4a0b21b3066540398.svg";
export { ForwardRef as ReactComponent };